import { render, staticRenderFns } from "./SettingsDelete.vue?vue&type=template&id=37c471e8"
import script from "./SettingsDelete.vue?vue&type=script&lang=js"
export * from "./SettingsDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports